module.exports = __webpack_public_path__ + "img/banner-m.cb0548f5.png";